<template>
  <div>
    <ion-item>
        <ion-spinner v-if="loading"></ion-spinner>
        <google-map
            :center="position"
            :zoom="12"
            style="width: 100%; height: 300px;"
            :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false }"
            v-if="position">
            <google-marker
                :position="position"
                :clickable="true"
                :draggable="true"
                @dragend="markerDragged"/>  
        </google-map>
    </ion-item>
    <ion-grid>
        <ion-row>
            <ion-col>
                <ion-button color="primary" expand="block" fill="outline" size="small" v-on:click="currentLocation">
                    <ion-icon slot="start" color="primary" ios="ios-locate" md="md-locate"/>
                    Detect Location
                </ion-button>
            </ion-col>      
        </ion-row>
    </ion-grid>
  </div>
</template>

<script>
import Field from "../models/Field";
import Value from "../models/Value";
import Helpers from "../mixins/Helpers";
import Plugins from "../mixins/Plugins";
import { gmapApi } from 'vue2-google-maps'
export default {
  name: "field-location",
  mixins: [
    Helpers,
    Plugins
  ],
  components: {},
  props: ["field", "value"],
  computed: {
    google: gmapApi
  },
  data() {
    return {
      loading: false,
      position: undefined
    };
  },
  async mounted() {
    this.loading = true;
    await this.currentLocation();
    this.loading = false;
  },
  methods: {
    async currentLocation() {
      try {
        let coordinates = await this.detectLocation();
        this.position = {
            lat: coordinates.latitude,
            lng: coordinates.longitude
        };
        this.value.value = `${coordinates.latitude}, ${coordinates.longitude}`;
      }
      catch (error) {
        this.showError("Problem Detecting Location", error);
        this.position = undefined;
        this.value.value = "";
      }
    },
    markerDragged(event) {
      if (event && event.latLng) {
        this.value.value = `${event.latLng.lat()}, ${event.latLng.lng()}`;
      }
    }
  }
}
</script>

<style scoped>
.vue-map-container {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>